module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "formTitle titleFont"
  }, [_vm._v("考试类型")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.colspanNum
    }
  }, [
    [_c('el-radio-group', {
      model: {
        value: (_vm.configForm.examType),
        callback: function($$v) {
          _vm.$set(_vm.configForm, "examType", $$v)
        },
        expression: "configForm.examType"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("普通考试")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("过程性考试")])], 1)]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "formTitle titleFont"
  }, [_vm._v("成绩类型")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.colspanNum
    }
  }, [
    [_c('el-radio-group', {
      model: {
        value: (_vm.configForm.scoreType),
        callback: function($$v) {
          _vm.$set(_vm.configForm, "scoreType", $$v)
        },
        expression: "configForm.scoreType"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("数字成绩")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("文字成绩")])], 1)]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "formTitle titleFont"
  }, [_vm._v("实训成绩")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.colspanNum
    }
  }, [
    [_c('el-radio-group', {
      on: {
        "change": _vm.handleTrainingChange
      },
      model: {
        value: (_vm.configForm.hasTraining),
        callback: function($$v) {
          _vm.$set(_vm.configForm, "hasTraining", $$v)
        },
        expression: "configForm.hasTraining"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("有")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("无")])], 1)]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "formTitle titleFont",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n                总评计算比例\n            ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "subTitle titleFont"
  }, [_vm._v("\n                平时\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "subTitle titleFont"
  }, [_vm._v("\n                期中\n            ")]), _vm._v(" "), (_vm.trainingVisible) ? _c('td', {
    staticClass: "subTitle titleFont"
  }, [_vm._v("\n                实训\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "subTitle titleFont"
  }, [_vm._v("\n                期末\n            ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titleFont",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("\n                默认一\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.usualRatio_1),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "usualRatio_1", $$v)
      },
      expression: "configForm.usualRatio_1"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.midRatio_1),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "midRatio_1", $$v)
      },
      expression: "configForm.midRatio_1"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1), _vm._v(" "), (_vm.trainingVisible) ? _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.trainingRatio_1),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "trainingRatio_1", $$v)
      },
      expression: "configForm.trainingRatio_1"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.finalRatio_1),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "finalRatio_1", $$v)
      },
      expression: "configForm.finalRatio_1"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titleFont",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("\n                默认二\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.usualRatio_2),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "usualRatio_2", $$v)
      },
      expression: "configForm.usualRatio_2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.midRatio_2),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "midRatio_2", $$v)
      },
      expression: "configForm.midRatio_2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1), _vm._v(" "), (_vm.trainingVisible) ? _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.trainingRatio_2),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "trainingRatio_2", $$v)
      },
      expression: "configForm.trainingRatio_2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "customPercent",
    style: ({
      width: _vm.inputWidth
    })
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.configForm.finalRatio_2),
      callback: function($$v) {
        _vm.$set(_vm.configForm, "finalRatio_2", $$v)
      },
      expression: "configForm.finalRatio_2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)]), _vm._v(" "), (_vm.passStandardConfig) ? _c('tr', [_c('td', {
    staticClass: "formTitle titleFont"
  }, [_vm._v("合格标准分")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.colspanNum
    }
  }, [
    [_c('el-input', {
      staticStyle: {
        "width": "180px"
      },
      attrs: {
        "oninput": "value=value.replace(/[^\\d]/g,'');value=value>100?100:value;"
      },
      model: {
        value: (_vm.configForm.passStandardScore),
        callback: function($$v) {
          _vm.$set(_vm.configForm, "passStandardScore", $$v)
        },
        expression: "configForm.passStandardScore"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("分")])], 2)]
  ], 2)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "60px",
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3064e814"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/setting/defaultConfig.vue
// module id = 1804
// module chunks = 502